export default __webpack_public_path__ + "static/media/pokemon_ultra_rare.fa491ae3.svg";